import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestAccounts = date => ({
  type: ActionTypes.REQUEST_ACCOUNT,
  date
})

export const receiveAccounts = (params, json) => ({
  type: ActionTypes.RECEIVE_ACCOUNT,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

export const getAccountsService = async params => {
  const data = {
    "process_type": "get_useraccount",
    "keys": params.keys,
    "offset": params.offset,
    "limit": params.limit
  };

  return await postApi(data);

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json());
}

const doFetchAccounts = params => async dispatch => {
  dispatch(requestAccounts(params))
  const data = {
    "process_type": "getUserAccount",
    ...params
    // "keys": params.keys,
    // "offset": params.offset,
    // "limit": params.limit
  };

  try {
    const json = await postApi(data);
    dispatch(receiveAccounts(params, json))
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json);
  //     dispatch(receiveAccounts(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchAccounts = params => (dispatch, getState) => {
  return dispatch(doFetchAccounts(params))
}

export const requestTimekeeping = data => ({
  type: ActionTypes.REQUEST_TIMEKEEPING,
  payload: data
});

export const receiveTimekeeping = json => ({
  type: ActionTypes.RECEIVE_TIMEKEEPING,
  receivedAt: Date.now(),
  data: json
});

export const sendTimekeepingData = data => async dispatch => {
  dispatch(requestTimekeeping(data));

  // const apiUrl = api.url;
  try {
    const json = await postApi(data);
    dispatch(receiveTimekeeping(json));
  } catch (error) {
    console.error('Error:', error);
  };
  // return fetch(apiUrl, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data)
  // })
  // .then(response => response.json())
  // .then(json => {
  //   dispatch(receiveTimekeeping(json));
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
};
